import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import User from '../shared/Utils/User';
import axios from 'axios';
import Alert from '../shared/Utils/AlertBox';
import Moment from 'react-moment';
import Loader from '../shared/components/Loader';
import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import swal from 'sweetalert';
import { useNavigate } from "react-router-dom";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useSearchParams } from "react-router-dom";

export default function DashboardCharts() {

  const user = User.getUser()
  const navigate = useNavigate();
  const [sequenceList, setSequenceList] = useState([])
  let [sequenceId, setSequenceId] = useState('');
  let [options, setOptions] = useState('');
  let [optionsColumn, setOptionsColumn] = useState('');
  let [optionsBar, setOptionsBar] = useState('');
  let [optionsDateWiseChart, setOptionsDateWiseChart] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getSequenceList();
  }, [])

  const getSequenceList = () => {
    let arr = [];
    arr.push({ P_sequence_id: searchParams.get("id") });
    // arr.push({ P_sequence_id: 126 });
    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    let url = `https://api.getbound.ai/api/user/getSequenceReports?Params=${p}`;
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {

        var option = {
          title: {
            text: 'Overall Results (Day ' +
              response.data.data[0].data[0].from_day + '-' +
              response.data.data[0].data[0].to_day + ')'
          },
          credits: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true
              }
            }
          },
          series: [{
            type: 'pie',
            data: response.data.data[2].data
          }
          ]
        }
        setOptions(option)



        let columnSeries = []
        let categories = [];

        response.data.data[1].data.forEach(d => {
          let _count
          _count = response.data.data[2].data
            .filter(q => (q.activity_type === d.activity_type) && (d.activity_type !== null))
            .map((x) => {
              return x._count;
            });


          let isNew = 0;
          if (columnSeries.length == 0) {
            isNew = 1;
            columnSeries.push({
              name: d.activity_type,
              type: "column",
              data: [[d._status, d._count]]
            })
            categories.push(d._status)
          }
          let matched = 0;
          let index = 0;

          if (isNew == 0) {
            for (let i = 0; i < columnSeries.length; i++) {
              if (columnSeries[i].name === d.activity_type) {
                matched = 1
                index = i
              }
            }

            if (matched == 0) {
              columnSeries.push({
                name: d.activity_type,
                type: "column",
                data: [[d._status, d._count]]
              })
              categories.push(d.activity_type)
            }
            else {
              columnSeries[index].data.push([d._status, d._count])
            }
          }
        })

        var optionColumn = {
          title: {
            text: response.data.data[0].data[0].sequence_name + ' Day ' +
              response.data.data[0].data[0].from_day + ' To ' +
              response.data.data[0].data[0].to_day
          },
          xAxis: {
            crosshair: true,
            type: "category",
            labels: {
              autoRotation: false
            },
          },
          yAxis: {
            type: 'logarithmic',
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              // pointPadding: 0.8,
              borderWidth: 0,
              dataLabels: {
                enabled: true
              }
            }
          },

          credits: {
            enabled: false
          },
          series: columnSeries
        }
        setOptionsColumn(optionColumn)


        let dayChart = [];
        response.data.data[3].data.forEach(d => {
          let dayData
          dayData = response.data.data[3].data
            .filter(q => (q._day === d._day) && (d._day !== null))
            .map((x) => {
              return x._percent;
            });

          dayChart.push({
            name: d._day,
            type: "bar",
            data: dayData

          })
        })

        var optionBar = {
          title: {
            text: response.data.data[0].data[0].sequence_name + ' Day ' +
              response.data.data[0].data[0].from_day + ' To ' +
              response.data.data[0].data[0].to_day
          },
          xAxis: {
            crosshair: true,
            // type: "category",
            labels: {
              autoRotation: false
            },
          },
          yAxis: {
            type: 'logarithmic',
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              // pointPadding: 0.8,
              borderWidth: 0,
              dataLabels: {
                enabled: true
              }
            }
          },
          tooltip: {
            formatter: function () {
              var numerator = 250;
              return ((this.y)).toFixed(1) + '%';
            }
          },
          credits: {
            enabled: false
          },
          series: dayChart
        }
        setOptionsBar(optionBar)


        /*Date Wise Chart Start*/
        let dateColumnSeries = []
        let dateCategories = [];

        response.data.data[4].data.forEach(d => {
          let _count
          _count = response.data.data[4].data
            .filter(q => (q._day === d._day) && (d._day !== null))
            .map((x) => {
              return x._count;
            });


          let isNew = 0;
          if (dateColumnSeries.length == 0) {
            isNew = 1;
            dateColumnSeries.push({
              name: d._day,
              type: "column",
              data: [[d.entry_date, d._count]]
            })
            dateCategories.push(d.entry_date)
          }
          let matched = 0;
          let index = 0;

          if (isNew == 0) {
            for (let i = 0; i < dateColumnSeries.length; i++) {
              if (dateColumnSeries[i].name === d._day) {
                matched = 1
                index = i
              }
            }

            if (matched == 0) {
              dateColumnSeries.push({
                name: d._day,
                type: "column",
                data: [[d.entry_date, d._count]]
              })
              dateCategories.push(d._day)
            }
            else {
              dateColumnSeries[index].data.push([d.entry_date, d._count])
            }
          }
        })

        var optionColumn = {
          title: {
            text: response.data.data[0].data[0].sequence_name + ' Day ' +
              response.data.data[0].data[0].from_day + ' To ' +
              response.data.data[0].data[0].to_day
          },
          xAxis: {
            crosshair: true,
            type: "category",
            labels: {
              autoRotation: false
            },
          },
          yAxis: {
            type: 'logarithmic',
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              // pointPadding: 0.8,
              borderWidth: 0,
              dataLabels: {
                enabled: true
              }
            }
          },
          credits: {
            enabled: false
          },
          series: dateColumnSeries
        }
        setOptionsDateWiseChart(optionColumn)
        /*Date Wise Chart End*/


      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
    })
  }



  function goToForm(e, data) {
    e.preventDefault();
    navigate('/sequence-report', { state: data });
  }

  return (
    <>
      <DashboardHeader />
      <div className="container-fluid page-body-wrapper">

        <SideMenu />
        {loader && <Loader />}
        <div className="main-panel">
          <div class="content-wrapper">
            <div class="row">

              <div className="col-md-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Reports</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options}
                />
              </div>
              <br>
              </br>
              <br>
              </br>
              <div className="col-md-12">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionsColumn}
                />
              </div>
              <div className="col-md-12">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionsBar}
                />
              </div>
              <div className="col-md-12">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionsDateWiseChart}
                />
              </div>




            </div>
          </div>


          <Footer />
        </div>
      </div>
    </>
  )
}